import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {apiClient} from '@common/http/query-client';

interface Response extends BackendResponse {
  plainTextToken: string;
}

export interface CreatePaynowPayload {
  amount: number;
  payment_method: string;
}

function createPaynow(
  payload: CreatePaynowPayload,
): Promise<Response> {
  return apiClient.post(`billing/stripe/create-paynow`, payload).then(r => r.data);
}

export function useCreatePaynow(
  form: UseFormReturn<CreatePaynowPayload>,
) {
  return useMutation({
    mutationFn: (props: CreatePaynowPayload) => createPaynow(props),
    onSuccess: () => {
      toast(message('You paid successfully.'));
    },
    onError: r => onFormQueryError(r, form),
  });
}
